module.exports = __webpack_public_path__ + "static/media/mechanical.795304d7.jpg";